import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelCase' })
export class CamelCasePipe implements PipeTransform {
    transform(value: string): any {
        if (value) {
            // value = this.checkSpecialString(value.toLowerCase());
            let specialProductCodesArray = ['401k','cd','sarsep', 'sep','sepp','jtwros','jttic','ira','nps','eps','ppf','epfo','isa','hsa','hra','grat','esa',
            'dccp','rdsp','gic','prif','lrif','srif','rif','lif','tfsa','rpp','lira','rlsp','lrsp','grsp','resp','nrsp','dpsp','srsp','rrsp','espp',
            'rsu','esop','utma','ugma','ulip', 'heloc'];
            let splString:any = specialProductCodesArray.join('|');
            splString = new RegExp('\\b('+splString+')\\b', "ig");
            value = value.toLowerCase().replace(splString, function (match) { 
               return match.toUpperCase() })
        } 
        return value;
    }

    // checkSpecialString(str: string): any {
    //     let specialProductCodesArray = ['401k', 'cd', 'sarsep', 'sep', 'sepp', 'jtwros', 'jttic', 'ira', 'nps', 'eps', 'ppf', 'epfo', 'isa', 'hsa', 'hra', 'grat', 'esa',
    //     'dccp','rdsp','gic','prif','lrif','srif','rif','lif','tfsa','rpp','lira','rlsp','lrsp','grsp','resp','nrsp','dpsp','srsp','rrsp','espp',
    //     'rsu','esop','utma','ugma','ulip', 'heloc'];
    //     let arrLength = specialProductCodesArray.length;
    //     while (arrLength--) {
    //         if (str.indexOf(specialProductCodesArray[arrLength]) != -1) {
    //             str = str.replace(specialProductCodesArray[arrLength], specialProductCodesArray[arrLength].toUpperCase());
    //         }
    //     }
    //     return str;
    // }
}
